import { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  Spinner,
  Modal,
  ModalBody,
  Button,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { getAttachedAthlete } from "store/actions/walletAction";
import ContractModal from "components/ContractModal";
import infoImage from "../assets/img/custom/schoolImage.jpg";
import collectiveImage from "../assets/img/custom/collectiveImage.jpg";
import collectiveAd from "../assets/img/custom/collectiveAd.jpg";
import schoolAd from "../assets/img/custom/schoolAd.jpg";
import bothAd from "../assets/img/custom/fanAthleteSchoolCollectiveAd.jpg";
import schoolImg from "../assets/img/custom/schoolAdImg.jpg";
import schoolImg2 from "../assets/img/custom/schoolAddImg5.png";
import schoolImg3 from "../assets/img/custom/schoolAddImg5 - Copy.png";
import img1 from "../assets/img/custom/image (3).png";
import PdfViewer from "components/PdfViewer ";
import pdfFile1 from "../assets/pdf/Partner Ad Working URL.pdf";
import pdfFile2 from "../assets/pdf/Partner Ad-Football.pdf";
import pdfFile3 from "../assets/pdf/Catch Ad 5-11.pdf";
import AdExchangeImg from "../assets/img/custom/adExchange.png";
import { updateUserDeviceToken } from "store/actions/notificationsAction";
import { messaging } from "config/firebase";

const Index = (props) => {
  let dispatch = useDispatch();
  let auth = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);
  console.log("user: ", user);
  const [participant, setParticipant] = useState(0);
  const [dataLoader, setDataLoader] = useState(true);
  const [isOpenModal, setIsOpenModal] = useState(true);
  const [adModal, setAdModal] = useState(false);
  const [isOpenImg, setIsOpenImg] = useState(false);
  let isContract = auth.user?.contract ? true : false;

  const toggleAdModal = () => setAdModal(!adModal);
  const toggle = () => {
    setIsOpenModal(!isOpenModal);
  };

  const toggleImg = () => {
    setIsOpenImg(!isOpenImg);
  };

  useEffect(() => {
    dispatch(
      getAttachedAthlete(auth.uid, (data) => {
        setParticipant(data);
        setDataLoader(false);
      })
    );
  }, []);

  const createToken = async (user, dispatch) => {
    try {
      await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      const registration = await navigator.serviceWorker.ready;
      const currentToken = await messaging.getToken({
        vapidKey:
          "BKtBn0Hxuy7MmztJf28DCm_M5M3sygGUP4F5QESuGUo4toV1fS2-Ex-h_8EWhXbO1ze3g9yiLDK-mo105WcNhIM",
        serviceWorkerRegistration: registration,
      });

      console.log("Current FCM Token: ", currentToken);
      console.log("user.fcmToken: ", user.fcmToken);

      if (currentToken) {
        if (!user?.fcmToken || user.fcmToken !== currentToken) {
          dispatch(updateUserDeviceToken(currentToken, user.id));
        } else {
          console.log("Token unchanged, no update needed");
        }
      } else {
        console.log("No token available. Permission may be required.");
      }
    } catch (err) {
      console.error("Error retrieving FCM token: ", err);
    }
  };

  const requestNotificationPermission = async (user, dispatch) => {
    try {
      const permission = await Notification.requestPermission();
      console.log("permission: ", permission);

      if (permission === "granted") {
        console.log("Notification permission granted");
        await createToken(user, dispatch);
      } else if (permission === "denied") {
        console.log("Notification permission denied");
      } else {
        console.log("Notification permission dismissed (default state)");
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error);
    }
  };

  useEffect(() => {
    const initializeNotifications = async () => {
      if (!("Notification" in window) || !navigator.serviceWorker) {
        console.log(
          "Notifications or service workers not supported in this browser"
        );
        return;
      }
      console.log("Notification.permission: ", Notification.permission);
      if (Notification.permission === "granted") {
        await createToken(user, dispatch);
      } else if (Notification.permission === "default") {
        await requestNotificationPermission(user, dispatch);
      } else {
        console.log("Notifications previously denied by user");
      }
    };

    initializeNotifications();
  }, [user, dispatch]);

  return (
    <>
      <div className="header  pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="4" className="mb-2">
                <Card className="card-stats mb-4 mb-xl-0 h-100 ">
                  <CardBody>
                    <Row className="h-100">
                      <div className="col d-flex flex-column justify-content-between">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          contract signed date
                        </CardTitle>
                        {/* <span className="h2 font-weight-bold mb-0">
                          {moment
                            .unix(auth.user.created_at.seconds)
                            .format("DD-MM-YYYY")}
                        </span> */}
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fas fa-chart-bar" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="4" className="mb-2">
                <Card className="card-stats mb-4 mb-xl-0 h-100 ">
                  <CardBody>
                    <Row className="h-100">
                      <div className="col d-flex flex-column justify-content-between">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0 "
                        >
                          Attached Students
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {dataLoader ? (
                            <Spinner size="sm" color="primary" />
                          ) : (
                            participant
                          )}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-chart-pie" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              {auth.user.type == "school platform" && (
                <Col xs="12" className="mt-4">
                  <img src={img1} width="100%" />
                </Col>
              )}
              <PdfViewer
                pdfFile={pdfFile1}
                fileName="Partner_Ad_Working_URL.pdf"
              />
              <PdfViewer
                pdfFile={pdfFile2}
                fileName="Partner_Ad_Football.pdf"
              />
              <PdfViewer pdfFile={pdfFile3} fileName="Catch Ad 5-11.pdf" />
              <Col xs="12" className="mt-4">
                <img
                  src={
                    auth.user.type == "school platform"
                      ? infoImage
                      : collectiveImage
                  }
                  width="100%"
                />
              </Col>
              <Col xs="12">
                <img
                  src={
                    auth.user.type == "school platform"
                      ? schoolAd
                      : collectiveAd
                  }
                  width="100%"
                />
              </Col>
              <Col xs="12">
                <a href={bothAd} download="image.jpg">
                  <img src={bothAd} width="100%" />
                </a>
              </Col>
              <Col xs="12">
                {auth.user.type == "school platform" && (
                  <img src={schoolImg} width="100%" />
                )}
              </Col>
              <Col xs="12">
                {auth.user.type == "school platform" && (
                  <img
                    src={schoolImg2}
                    width="100%"
                    onClick={toggleImg}
                    className="pointer"
                  />
                )}
              </Col>
              <Col xs="12 mt-2">
                {auth.user.type === "school platform" && (
                  <div className="position-relative text-center">
                    <img
                      src={AdExchangeImg}
                      width="100%"
                      className="pointer"
                      alt="Ad Exchange"
                    />

                    <a
                      href={AdExchangeImg}
                      download="ad-exchange-image.jpg"
                      className="btn btn-primary mt-2"
                    >
                      Download Image
                    </a>
                    <a
                      onClick={toggleAdModal}
                      download="ad-exchange-image.jpg"
                      className="btn btn-primary m-2"
                    >
                      Explainer Video
                    </a>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </Container>
        <ContractModal contractModal={isContract} contractToggle={toggle} />
      </div>
      <Modal isOpen={isOpenImg} toggle={toggleImg} size="xl">
        <ModalBody>
          <img src={schoolImg3} alt="" width="100%" />
          <div className="text-right">
            <Button color="danger" onClick={toggleImg}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={adModal} toggle={toggleAdModal} centered size="sm">
        <ModalHeader toggle={toggleAdModal}>
          How to get your wallet address
        </ModalHeader>
        <ModalBody className="text-center">
          <video width="100%" height="70%" controls>
            <source
              src="https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/AdExchangeSchool.mp4?alt=media&token=39d15d48-9a38-42ba-b4af-4bb78c094d18"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAdModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Index;
